import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end" }

import StateSelect from "@/components/inputs/StateSelect.vue";
import {Task, State} from "@/types/Order";
import {ref, watch} from "vue";

//eventuell rückmelde datum zuzsätlich

export default /*@__PURE__*/_defineComponent({
  __name: 'CloseFeedbackForm',
  props: /*@__PURE__*/_mergeModels({
    onClose: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel<Task>(__props, "modelValue")

const localModel = ref<Task>(JSON.parse(JSON.stringify(model.value)));
localModel.value.state = State.beend;

const props = __props

watch(() => model, (newVal) => {
  localModel.value = JSON.parse(JSON.stringify(newVal))
})

function submit() {
  model.value.state = localModel.value.state;
  props.onClose?.()
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StateSelect, {
      modelValue: localModel.value.state,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel.value.state) = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        text: "Save",
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            color: "green",
            icon: "mdi-checkbox-marked-circle",
            start: ""
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Ok "))
        ]),
        _: 1,
        __: [1]
      })
    ])
  ], 64))
}
}

})